import { EditableComponent } from '@adobe/aem-react-editable-components';
import { CNAnimatedBanner as CNAnimatedBannerComp, type CNAnimatedBannerProps } from '../../molecules/CNAnimatedBanner';

export const CNAnimatedBannerConfig = {
  emptyLabel: 'CNAnimatedBanner',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/animatedbanner`,
};

export const CNAnimatedBanner = (props: CNAnimatedBannerProps) => {
  return (
    <div data-testid="o-cn-homepage-animatedbanner" data-component-name="o-cn-homepage-animatedbanner">
      <EditableComponent config={CNAnimatedBannerConfig} {...props}>
        <CNAnimatedBannerComp {...props} />
      </EditableComponent>
    </div>
  );
};
